import { IRootState } from 'reducers';
import { createSelector } from 'reselect';

const proforientationResultLinkSelector = createSelector(
  [(state: IRootState) => state.proforientation],
  (proforientation) => {
    return proforientation.content?.testing?.url ?? null;
  },
);

export default proforientationResultLinkSelector;
